export default {
    install(Vue: any, options: any = {store: null}) {
        
    }
}
